"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PrebindResolver_1 = require("../resolvers/prebinding/PrebindResolver");
var Prebinding = (function () {
    function Prebinding() {
    }
    Prebinding.registerPrebindHelper = function (helperName, handler) {
        this.processor.registerPrebindHelper(helperName, handler);
    };
    Prebinding.getHelper = function (helperName) {
        return this.processor.getHelper(helperName);
    };
    Prebinding.applyPrebindingOnElement = function (rootElement) {
        if (this.processor.hasNotAppliedPrebind(rootElement)) {
            this.processor.applyToElement(rootElement);
        }
    };
    Prebinding.applyPrebindingOnChildren = function (rootElement) {
        var _this = this;
        this.nodeListToArray(rootElement.querySelectorAll("*"))
            .map(function (element) { return element; })
            .filter(function (element) { return _this.processor.hasNotAppliedPrebind(element); })
            .forEach(function (element) { return _this.processor.applyToElement(element); });
    };
    Prebinding.nodeListToArray = function (elements) {
        var array = [];
        for (var i = 0, length = elements.length; i < length; i++) {
            array.push(elements[i]);
        }
        return array;
    };
    return Prebinding;
}());
Prebinding.processor = new PrebindResolver_1.PrebindResolver();
exports.Prebinding = Prebinding;



//////////////////
// WEBPACK FOOTER
// ./src/base/Prebinding.ts
// module id = 2
// module chunks = 13 14